import { render, staticRenderFns } from "./AmountChange.vue?vue&type=template&id=404fa4ae&scoped=true"
import script from "./AmountChange.vue?vue&type=script&lang=js"
export * from "./AmountChange.vue?vue&type=script&lang=js"
import style0 from "./AmountChange.vue?vue&type=style&index=0&id=404fa4ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404fa4ae",
  null
  
)

export default component.exports